import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, User, LogOut } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsLoggedIn(false);
    navigate('/');
  };

  return (
    <nav className="fixed w-full top-0 z-50 bg-slate-950/90 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_reprogramhub/artifacts/svj7oofe_AE5BB2FE-CF26-419F-A4F4-55E3C5281906.png" 
              alt="JC Performance-57 Logo" 
              className="h-14 w-auto"
            />
            <span className="text-2xl font-bold text-white hidden sm:inline-block whitespace-nowrap">
              JC Performance<span className="text-red-600">-57</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/#services" className="text-gray-300 hover:text-red-600 transition-colors">Services</a>
            <a href="/#tarifs" className="text-gray-300 hover:text-red-600 transition-colors">Tarifs</a>
            <a href="/#contact" className="text-gray-300 hover:text-red-600 transition-colors">Contact</a>
            <a 
              href="https://outil.jcperformance57.fr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-red-600 transition-colors font-semibold"
            >
              📁 Service de fichier
            </a>
            
            {/* ESPACE PRO EN HAUT */}
            {isLoggedIn ? (
              <div className="flex items-center space-x-4">
                <Button
                  onClick={() => navigate('/professional/dashboard')}
                  className="bg-red-600 hover:bg-red-700 text-white"
                >
                  <User className="mr-2 h-4 w-4" />
                  Mon Espace
                </Button>
                <Button
                  onClick={handleLogout}
                  variant="outline"
                  className="border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
                >
                  <LogOut className="mr-2 h-4 w-4" />
                  Déconnexion
                </Button>
              </div>
            ) : (
              <Button
                onClick={() => navigate('/professional/login')}
                className="bg-red-600 hover:bg-red-700 text-white"
              >
                <User className="mr-2 h-4 w-4" />
                Espace Pro
              </Button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white p-2"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-4">
            <a href="/#services" className="block text-gray-300 hover:text-red-600 transition-colors">Services</a>
            <a href="/#tarifs" className="block text-gray-300 hover:text-red-600 transition-colors">Tarifs</a>
            <a href="/#contact" className="block text-gray-300 hover:text-red-600 transition-colors">Contact</a>
            <a 
              href="https://outil.jcperformance57.fr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block text-gray-300 hover:text-red-600 transition-colors font-semibold"
            >
              📁 Service de fichier
            </a>
            
            {isLoggedIn ? (
              <>
                <Button
                  onClick={() => navigate('/professional/dashboard')}
                  className="w-full bg-red-600 hover:bg-red-700 text-white"
                >
                  <User className="mr-2 h-4 w-4" />
                  Mon Espace
                </Button>
                <Button
                  onClick={handleLogout}
                  variant="outline"
                  className="w-full border-red-600 text-red-600"
                >
                  <LogOut className="mr-2 h-4 w-4" />
                  Déconnexion
                </Button>
              </>
            ) : (
              <Button
                onClick={() => navigate('/professional/login')}
                className="w-full bg-red-600 hover:bg-red-700 text-white"
              >
                <User className="mr-2 h-4 w-4" />
                Espace Pro
              </Button>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;